/* esm.sh - nostr-tools@2.23.3/nip98 */
export * from "/*nostr-tools@2.23.3/esnext/nip98.mjs";
